import React, { Component } from 'react'

import styled from 'styled-components'

/* eslint-disable */
window.NodeList.prototype.forEach = Array.prototype.forEach

window.Node.prototype.contains = function contains(node) {
	if (!(0 in arguments)) {
		throw new TypeError('1 argument is required')
	}

	while (node = node && node.parentNode){
		if (this === node) {
			return true
		}
  }

	return false
};
/* eslint-enable */

export default class EquipmentsSvg extends Component {
  onSvgClick = (e) => {
    const { onClickElement } = this.props
    const elementId = e.target.id
    const interactiveBox = document.getElementById('elementos-interativos')

    let element = document.getElementById(elementId)

    // Check if elements exist
    if (element && interactiveBox) {
      const parent = element.parentNode
      // Check if element is interactive
      const isInteractive = interactiveBox.contains(element)

      // Toggle equipment
      if (isInteractive) {
        // If is a group of equipments
        if (parent.id !== 'elementos-interativos') {
          element = parent
        }

        // Ser gradient fill
        if (!element.style.fill) {
          element.style.cssText = 'fill: url(#gradient)'
        } else {
          element.style.cssText = ''
        }

        // Trigger
        onClickElement(element.id)
      }
    }
  }

  triggerSelected = () => {
    const interactiveBox = document.getElementById('elementos-interativos')
    if (interactiveBox) {
      const allInteractive = interactiveBox.querySelectorAll('path')
      allInteractive.forEach(ele => ele.setAttribute('class', 'clickable'))
    }

    const { currentEquipments, hiddenSvgItems } = this.props
    currentEquipments &&
      currentEquipments.forEach(({ svg_key }) => {
        const element = document.getElementById(svg_key)
        if (element) {
          element.style.cssText = 'fill: url(#gradient)'
        }
      })

    hiddenSvgItems &&
      hiddenSvgItems.forEach((id) => {
        const element = document.getElementById(id)
        if (element) {
          element.style.cssText = 'fill: #DEDEDE'
          element.setAttribute('class', '')
          if (element.tagName === 'g') {
            element.querySelectorAll('path')
              .forEach(ele => ele.setAttribute('class', ''))
          }
        }
      })
  }

  componentDidUpdate () {
    this.triggerSelected()
  }

  componentDidMount () {
    this.triggerSelected()
  }

  render () {
    const { svg } = this.props

    const SvgComponent = (props) => (
      <SvgWrapper {...props} dangerouslySetInnerHTML={{ __html: svg }} />
    )

    return (
      <Wrapper>
        <SvgComponent
          ref={(ref) => { this.svgRef = ref }}
          onClick={this.onSvgClick}
        />
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
`

const SvgWrapper = styled.div`
  margin: 0 auto;
  border: 1px solid #EFEFEF;
  margin-top: 45px;

  #elementos-interativos .clickable {
    cursor: pointer;
    pointer-events: bounding-box;
  }

  svg {
    width: 100%!important;
  }
`



// WEBPACK FOOTER //
// ./src/containers/EquipmentsSvg/index.js